'use client';

import { type ReactElement } from 'react';
import { ChevronLeftIcon } from '@/shared-ui/icons';
import { MenuItem } from '@/shared-ui/molecules/menu-item';

type BurgerMenuSubmenuHeaderProps = {
    title: string;
    onBack: () => void;
};

export const BurgerMenuSubmenuHeader = ({ title, onBack }: BurgerMenuSubmenuHeaderProps): ReactElement => {
    return (
        <MenuItem
            textAlign="center"
            textVariant="h4"
            leftIcon={ChevronLeftIcon}
            balanceSideIcons
            className="rounded-none uppercase"
            backgroundColor="#f6f2ed"
            onClick={onBack}>
            {title}
        </MenuItem>
    );
};
